/* Ala ship-note (D-128, 2026-07-24) — cutoff-aware delivery promise under the
   checkout CTA (cart drawer + cart page). Spec: reports/2026-07-24-ships-fast-cart-callout-spec.md
   Ops promise behind the copy: Alanah packs a USPS batch by 6:00 AM MT, Mon-Sat
   (explicitly confirmed 2026-07-24). States:
     - Mon-Sat 00:00-06:00 Denver  -> countdown "ships today"
     - next batch day = tomorrow   -> "Ships by tomorrow"
     - Sat after 6am (next = Mon)  -> "Ships Monday"
     - holiday-shifted / else      -> fallback "Ships within 1-2 business days"
   Pre-order (tag presale/preorder-batch2) carts: swap/split so Batch #2 items
   never inherit the promise (split-ship policy, approved 2026-07-24). */
(function () {
  'use strict';
  var CFG = {
    tz: 'America/Denver',
    cutoffHour: 6,
    batchDays: [1, 2, 3, 4, 5, 6], /* Mon..Sat */
    holidays: ['2026-09-07', '2026-10-12', '2026-11-11', '2026-11-26',
               '2026-12-25', '2027-01-01', '2027-01-18'],
    b2Note: 'Batch #2 items ship separately when in stock'
  };
  var WD = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  var nowFmt, dayFmt;

  function denverNow(at) {
    nowFmt = nowFmt || new Intl.DateTimeFormat('en-US', {
      timeZone: CFG.tz, hour12: false, weekday: 'short',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    });
    var p = {};
    nowFmt.formatToParts(at || new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { hh: (+p.hour) % 24, mm: +p.minute, ss: +p.second, wd: WD[p.weekday] };
  }

  function dayAt(offset, at) {
    dayFmt = dayFmt || new Intl.DateTimeFormat('en-CA', {
      timeZone: CFG.tz, weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit'
    });
    var t = (at ? at.getTime() : Date.now()) + offset * 86400000;
    var p = {};
    dayFmt.formatToParts(new Date(t)).forEach(function (x) { p[x.type] = x.value; });
    return { iso: p.year + '-' + p.month + '-' + p.day, wd: WD[p.weekday] };
  }

  function isBatch(day) {
    return CFG.batchDays.indexOf(day.wd) >= 0 && CFG.holidays.indexOf(day.iso) < 0;
  }

  function state(at) {
    var n = denverNow(at);
    for (var off = 0; off <= 7; off++) {
      var day = dayAt(off, at);
      if (off === 0) {
        if (n.hh < CFG.cutoffHour && isBatch(day)) {
          return { k: 'today', secs: CFG.cutoffHour * 3600 - (n.hh * 3600 + n.mm * 60 + n.ss) };
        }
        continue;
      }
      if (isBatch(day)) {
        if (off === 1) return { k: 'tomorrow' };
        if (off === 2 && day.wd === 1) return { k: 'monday' };
        return { k: 'fallback' };
      }
    }
    return { k: 'fallback' };
  }

  function hm(s) {
    var h = Math.floor(s / 3600), m = Math.ceil((s % 3600) / 60);
    if (m === 60) { h++; m = 0; }
    return (h ? h + 'h ' : '') + m + 'm';
  }

  function lead(st, mixed) {
    if (st.k === 'today') {
      return mixed
        ? 'In-stock items ship today — order in the next ' + hm(st.secs)
        : 'Order in the next <strong>' + hm(st.secs) + '</strong> — ships today';
    }
    if (st.k === 'tomorrow') return mixed ? 'In-stock items ship by tomorrow' : 'Ships by tomorrow';
    if (st.k === 'monday') return mixed ? 'In-stock items ship Monday' : 'Ships Monday';
    return mixed ? 'In-stock items ship within 1–2 business days' : 'Ships within 1–2 business days';
  }

  function render() {
    var els = document.querySelectorAll('[data-ala-ship]');
    if (!els.length) return;
    var st = state();
    var emoji = st.k === 'fallback' ? '📦' : '🚚';
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var po = +el.getAttribute('data-po') || 0;
      var items = +el.getAttribute('data-items') || 0;
      var html;
      if (po > 0 && po >= items) {
        html = '🗓 Batch #2 pre-order — ships when in stock';
      } else if (po > 0) {
        html = emoji + ' ' + lead(st, true) +
          '<span class="ala-ship-b2">🗓 ' + CFG.b2Note + '</span>';
      } else {
        html = emoji + ' ' + lead(st, false);
      }
      if (el.__alaShip !== html) { el.innerHTML = html; el.__alaShip = html; }
    }
  }

  function init() {
    render();
    setInterval(render, 20000);
    /* drawer re-renders replace our node — re-render idempotently on DOM change */
    new MutationObserver(render).observe(document.body, { childList: true, subtree: true });
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { state: state, lead: lead, hm: hm, CFG: CFG }; /* Node tests */
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
